export const instancesInArray = (array, key, value) => {
  if(array && array.length){
    return array.filter(item => item[key] === value).length
  } else {
    return 0
  }
}